// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1tXu2","top":"styles_top__2aFBF"};